import { IsPrintingAtom } from "./atoms";
import * as React from "react";
import { Sidebar } from "./sidebar";
import { Graph } from "./graph";
import { ResultHeader } from "./resultHeader";
import { useAtom } from "jotai";
import { Table } from "./table";
import * as strings from "./strings";
import { useNav } from "./useNav";

const { back_string, print_string } = strings;

export const StepResult = React.forwardRef<HTMLDivElement>(function StepResult(
  p,
  ref
) {
  const { prev } = useNav();
  const [isPrint, setIsPrint] = useAtom(IsPrintingAtom);

  return (
    <div className="result-wrapper" ref={ref}>
      <ResultHeader />
      <div className="atc-result-content">
        <Sidebar />
        <Graph />
      </div>
      {!isPrint ? (
        <div className="atc-button-group">
          <button className="button white" onClick={prev}>
            {back_string}
          </button>
          <button
            className="button auto white print-btn"
            onClick={() => {
              setIsPrint(true);
            }}
          >
            {print_string}
          </button>
        </div>
      ) : null}
    </div>
  );
});
